import React from 'react';

export default function TablePadding({ children }) {
	return <div className="table-padding">
		{children}
	</div>;
}
